import FormField from "./FormField";
import IsADateValidator from "./validators/IsADateValidator";

export default class DateField extends FormField {
  constructor (initialValue = null) {
    super(initialValue);
    this._validators = [new IsADateValidator()];
  }
}
